import { render, staticRenderFns } from "./InfoTb.vue?vue&type=template&id=02f342af"
import script from "./InfoTb.vue?vue&type=script&lang=js"
export * from "./InfoTb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports